import React from 'react'
import { TextProps, Text } from '@ui-kitten/components'
import { colors } from '../theme'

type Status = 'info' | 'warning' | 'danger' | 'success'

interface Props extends Omit<TextProps, 'status'> {
  status?: Status
}

function getColor(status: Status | undefined) {
  if (status === 'info') return colors.accentText
  if (status === 'warning') return colors.warning
  if (status === 'danger') return colors.error
  if (status === 'success') return colors.success
  return colors.accent
}

export const BtBadge = ({ status, style, ...props }: Props) => {
  const backgroundColor = getColor(status)

  return (
    <Text
      style={[
        {
          backgroundColor,
          color: 'white',
          fontSize: 11,
          borderRadius: 3,
          paddingVertical: 2,
          paddingHorizontal: 4,
          fontWeight: '700',
        },
        style,
      ]}
      {...props}
    />
  )
}
